module.exports = __webpack_public_path__ + "img/icon0.e61d47ef.png";